import { useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { toast } from "sonner";

export function RenewalResetButton({ company, live, onDone }) {
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const id = company.company_id;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post(`/admin/subscriptions/${id}/renewal-reset`, { reason });
      toast.success("Yenileme yeniden denemeye açıldı");
      setOpen(false);
      setReason("");
      onDone?.();
    } catch (err) {
      toast.error(err?.response?.data?.detail || "İşlem yapılamadı");
    } finally { setBusy(false); }
  };

  return (
    <>
      <Button size="sm" variant="outline" onClick={() => setOpen(true)} data-testid={`diag-reset-btn-${id}`}>
        Yeniden Denemeye Aç
      </Button>
      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogContent data-testid="diag-reset-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle>Yenileme yeniden denemeye açılsın mı?</AlertDialogTitle>
            <AlertDialogDescription>
              Önceki başarısız deneme silinmez, denetim için saklanır. Sıradaki cron çalışmasında yeni sipariş numarasıyla tekrar denenir.
              {live ? " DİKKAT: Sistem canlı modda — sıradaki cron GERÇEK tahsilat yapar." : " Sistem dry-run modunda — gerçek tahsilat yapılmaz."}
            </AlertDialogDescription>
          </AlertDialogHeader>
          <Textarea
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Sıfırlama nedeni (ör. PayTR recurring yetkisi açıldı)"
            data-testid="diag-reset-reason-input"
          />
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="diag-reset-cancel">Vazgeç</AlertDialogCancel>
            <AlertDialogAction onClick={submit} disabled={busy || reason.trim().length < 3} data-testid="diag-reset-confirm">
              {busy ? "Kaydediliyor..." : "Yeniden Denemeye Aç"}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}

export default RenewalResetButton;
